var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{attrs:{"tableTitle":_vm.tableTitle,"pageFooter":true,"InfoHref":_vm.InfoHref,"deleteUrl":'api/exam/delete',"searchUrl":_vm.url,"statistics":true,"statistics_":true,"statis-href":`AssessStatistics`,"tableType":1,"form":_vm.form,"scale_title":true,"add":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }